/* ============================================================
   HONEY BAE | lander H, "the affair question" : THE SOURCE REGISTER

   The article on this page is a SUPPLIED SCRIPT (SCRIPT.pdf, "Honey Bae Native
   Ad 14_08", supplied by Omar 2026-08-15 and kept beside the page as
   provenance). It lives in this file rather than in the markup so the client's
   prose is in one auditable place, can be diffed against the original, and a
   revised script is one file to swap. Ported from Veyla's lander H, which is
   the same contract on a different brand.

   THIS PAGE IS WRITTEN IN THE FIRST PERSON AND THE NARRATOR DOES NOT EXIST.
   The supplied script's own publishing note says so and requires it to be said
   out loud, so it is:

     - the narrator has NO NAME, NO FACE and NO PHOTOGRAPH. Neither does the
       friend. Every photograph on the page is Honey Bae's own product
       photography, and the four shots in the library that carry a man's face
       are banned by filename in the harness. See ART.
     - a standing disclosure sits under the byline, above the story, and is
       repeated in the FAQ. It says the account is a composite dramatization,
       that no photograph on the page is of them, and that the reviews further
       down are real.
     - FICTION below is the register: INVENTED, CLIENT_SOURCED, OUTSIDE and
       REAL, so nothing on the page is unattributed by accident.

   THE SUBJECT IS THE OTHER HALF OF THE RISK. The script is about erectile
   difficulty, and Honey Bae is a food supplement, not a medicine. So the page
   carries the narrator's account as an account, adds no efficacy claim of its
   own anywhere, refuses the one real store review that reports an erectile
   result (see REFUSED.testimonial), and puts the "see a doctor" disclosure in
   two places rather than one. Read REFUSED before adding a single sentence.

   THE SWAPS OMAR APPROVED 2026-08-15 are all recorded below with the original
   wording: profanity out, the one graphic line rewritten, em dashes to commas.

   The registers:
     SCRIPT   the supplied copy, rewritten only where SWAPS says. The article.
     SWAPS    what was changed, what it said before, and why. Auditable.
     FICTION  who is invented, whose claim each figure is, what is real.
     BRAND    Honey Bae's own claims about the product, attributed out loud.
     OUTSIDE  the alternatives the script names, and the one it should name.
     ART      every photograph the page uses, with the size of the file on disk.
     BUY      the offer panel's own wording. It routes, so it names no plan id.
     REVIEWS  real store reviews, under the names they were left under.
     REFUSED  what this page will not say.

   NO PRICE IS TYPED IN THIS FILE. Every figure the panel and the table print is
   computed from ../../shared/hb-offer.js at runtime.
   ============================================================ */
(() => {

  /* ---------- SWAPS: what the script says, and what this page says ---------- */
  const SWAPS = {
    profanity: {
      script: 'nine instances: "After fucking 11 years of marriage", "The fucked-up part", ' +
              '"I loved the hell out of her", "embarrassed as hell", "what the fuck was I ' +
              'supposed to say", "Googling shit I never thought I’d Google", "Yeah, no ' +
              'shit", "getting fucked up", "what the hell was even in it", "another random ' +
              'bullshit", "if you fuck up again", "some fucking superhero", "another piece ' +
              'of bullshit", "a hell of a lot better", "random shit from the gas station"',
      page:   'the same sentences, the same rhythm, no swearing',
      why:    'Omar, 2026-08-15. Two reasons rather than taste. Meta prohibits ' +
              'profanity in ad copy, and the copy that runs the traffic to this ' +
              'page is lifted off this page. And it is the client’s own store, ' +
              'in the client’s voice. Nothing in the argument needed the words: ' +
              'every sentence that carried one is otherwise intact.'
    },
    graphic: {
      script: '"Hey man, sometimes I can’t get my d*ck hard when I’m with my wife. ' +
              'And wtf am I supposed to do about it?"',
      page:   '"Hey man, sometimes my body doesn’t cooperate when I’m with my ' +
              'wife. And what am I supposed to do about it?"',
      why:    'Omar, 2026-08-15. The line has to stay unmistakable, because the ' +
              'whole page is about a man who could not say it out loud, and a ' +
              'euphemism would make the paragraph about nothing. It does not ' +
              'have to be graphic: the script itself already uses "my body just ' +
              'wouldn’t cooperate" two paragraphs earlier, so this is the ' +
              'script’s own wording rather than ours.'
    },
    dashes: {
      script: 'em dashes throughout',
      page:   'commas, colons and full stops',
      why:    'House rule. No em dashes or en dashes in any authored copy. The ' +
              /* the en dash below is written as an escape on purpose: this is a
                 verbatim record of what the script said, and the house rule
                 bans the literal character from every source file we author. */
              'script’s "15\u201330 minutes" is written "15 to 30 minutes" for the ' +
              'same reason.'
    },
    /* Not a copy change: a decision about what the page prints beside the copy. */
    ratings: {
      script: 'the script quotes no rating and no review count',
      page:   'and neither does this page',
      why:    'The client’s own product page carries three counts that ' +
              'contradict each other: "43,000+ satisfied customers", "203,000+ ' +
              '5-star reviews" with an asterisk, and "over 1,571 five star ' +
              'reviews". A page cannot print a number whose own source disagrees ' +
              'with itself three times, so this one prints none of them and ' +
              'quotes named reviews instead. Flagged for Omar in the README.'
    },
    shipping: {
      script: '"included free priority shipping and 5 free Gold Shilajit gummies"',
      page:   'the same, and both were verified on the live store 2026-08-15',
      why:    'Kept verbatim because it checks out: "Free priority shipping" is a ' +
              'real gift product on the store (handle free-priority-shipping) and ' +
              'the store’s own bar reads "Welcome Kit: 30% OFF + 5 Free Gold ' +
              'Shilajit Gummies". Recorded here so a future reader knows it was ' +
              'checked rather than assumed.'
    }
  };

  /* ---------- FICTION: who is invented, and whose claim each figure is ---------- */
  const FICTION = {
    INVENTED: [
      'The narrator. No name, no face, no photograph. Forty-two and eleven years ' +
      'married are the script’s own details and are kept as his.',
      'The wife, and her one line of dialogue.',
      'The friend, and all of his dialogue. Unnamed in the script and unnamed here.',
      'The whole sequence of events: the three times that month, the 2 AM ' +
      'searching, the beers, the link, the delivery and the evening after it.',
      'Everything the narrator reports feeling. It is his account, hedged as his, ' +
      'and the page makes no claim of its own from it.'
    ],
    CLIENT_SOURCED: [
      'Honey Bae is honey in single-use 15g sachets, 12 to a pack.',
      'Panax ginseng, Peruvian maca, tongkat ali and tribulus terrestris, the ' +
      'botanicals the product page lists.',
      'One sachet taken directly, around 15 to 30 minutes beforehand.',
      'The 60-day money-back guarantee, published on the product page.',
      'The 3-month delivery plan at 30% off, free priority shipping and 5 free ' +
      'Gold Shilajit gummies, all live on the store 2026-08-15.'
    ],
    OUTSIDE: [
      'The two gas station brands the script names, "Black Bull" and "Extreme ' +
      'Man". They are real products and they are named as the script named them, ' +
      'in the narrator’s account of what he tried, with no claim made about ' +
      'either one beyond his own "I had no idea what was even in it".',
      'That erectile difficulty can be a symptom of cardiovascular disease, ' +
      'diabetes, low testosterone or a medication side effect. Standard published ' +
      'medical guidance, stated as guidance and not as a finding about anybody.'
    ],
    REAL: [
      'Both reviews quoted on this page. Honey Bae’s own store reviews, ' +
      'reproduced as written, under the names they were left under.',
      'Every price, percentage and term on the page, computed from the live ' +
      'product and the live selling plan.'
    ]
  };

  /* ---------- SCRIPT: the supplied copy ----------
     Paragraph for paragraph with SCRIPT.pdf. The hook is the wife's question,
     so that is the headline; the second paragraph is the standfirst; the middle
     is beats; the last four paragraphs are the close and the sign-off. */
  const SCRIPT = {
    headTop: 'After 11 years of marriage,',
    headMid: 'my wife asked if I was',
    headEm:  'having an affair.',

    /* the byline, and the disclosure that has to travel with it */
    byline: 'A Honey Bae customer story',
    bylineNote:
      'A first-person account supplied to Honey Bae. The narrator and the friend ' +
      'in it are a composite dramatization, they are unnamed, and no photograph on ' +
      'this page is of either of them. Nothing here is medical advice, and Honey ' +
      'Bae is a food supplement rather than a treatment. The reviews further down ' +
      'are real store reviews under the names they were left under.',

    intro:
      'She asked because it had happened three times that month. We would be in bed, ' +
      'everything would be good, and then my body just would not cooperate. The worst ' +
      'part? I did not even understand why it was happening.',

    /* THE BEATS ARE LABELLED, NOT NUMBERED. This is an account, and numbering an
       account promises a count that nothing in the copy owes the reader. Every
       head below is a sentence the script itself wrote. */
    beats: [
      { pill: 'What was wrong',
        head: 'Nothing was wrong between us. Or at least, that is what I thought.',
        body: 'I was attracted to her. I loved her more than anything. Nothing was wrong ' +
              'between us, or at least, that is what I thought. But every time we got close, ' +
              'I would get stuck in my head and start worrying about whether my body was ' +
              'going to cooperate. Then I would panic, which obviously made everything even ' +
              'worse.' },

      { pill: 'The silence',
        head: 'I was 42 years old and completely embarrassed.',
        body: 'At first, I did not tell anyone. I was 42 years old and completely ' +
              'embarrassed. I mean, what was I supposed to say? "Hey man, sometimes my body ' +
              'does not cooperate when I am with my wife. And what am I supposed to do about ' +
              'it?" Even typing that now sounds ridiculous, but that was genuinely where I ' +
              'was at.' },

      { pill: '2 AM',
        head: 'Just relax. Yeah, obviously.',
        body: 'So I did what I am guessing a lot of men like me do when they are too ' +
              'embarrassed to talk to anyone about that stuff: I stayed up late scrolling ' +
              'through Reddit, reading random forums, and Googling things I never thought I ' +
              'would Google. I was looking up things like why this kept happening, why I was ' +
              'panicking when I was still attracted to my own wife, and whether it meant ' +
              'something was seriously wrong with me. Honestly, most of the advice felt ' +
              'useless. It was always "just relax" or "stop stressing about it." Yeah, ' +
              'obviously. If I could have just relaxed, I would not have been lying awake at ' +
              '2 AM wondering whether my marriage was slowly falling apart because I could ' +
              'not get out of my own head.' },

      { pill: 'The gas station',
        head: 'I had no idea what was even in it.',
        body: 'Then I started seeing the pills and those random honey packs at gas stations, ' +
              'stuff with names like "Black Bull" and "Extreme Man." I tried one once because ' +
              'I was desperate. Looking back, that was stupid. I had no idea what was even in ' +
              'it, and that honestly scared me enough that I did not want to try another ' +
              'random product after that.' },

      { pill: 'The friend',
        head: 'You are just waiting to see if you mess up again.',
        body: 'I finally told one of my closest friends after a few beers one night. I ' +
              'expected him to laugh, tell me to take a stronger pill, or give me some dumb ' +
              '"just be confident" speech. Instead, he got quiet for a second and said, ' +
              '"Dude, you are probably doing what I did. One bad night happens, then you ' +
              'start waiting for it to happen again. By the time you are in bed, you are not ' +
              'even focused on her anymore. You are just waiting to see if you mess up ' +
              'again." I hated how much that made sense. That was exactly what it felt like. ' +
              'I was not thinking about my wife or enjoying being close to her. I was ' +
              'basically standing outside my own body, waiting to see whether I was going to ' +
              'disappoint her again.' },

      { pill: 'The link',
        head: 'Read it before you buy another piece of junk.',
        body: 'He said I should stop trusting some random black packet from the gas station ' +
              'when I did not even know what was in it. That honestly got my attention. He ' +
              'said something had helped him feel more confident and get out of his own head. ' +
              'I was not looking to become some superhero in bed. I just wanted to stop ' +
              'feeling anxious around my own wife and feel normal again. After we talked, I ' +
              'asked him what he took. Later that night, he sent me a link and said, "This is ' +
              'what I use. Just read it before you buy another piece of junk."' },

      { pill: 'What I read',
        head: 'Small sachets instead of some huge bottle or complicated routine.',
        body: 'So I clicked the link and looked into it. The first thing I noticed was that ' +
              'it came in small sachets instead of some huge bottle or complicated routine. ' +
              'It was honey with the ingredients listed, including Panax ginseng, maca, and ' +
              'tongkat ali, and the directions were pretty simple: tear open one sachet and ' +
              'take it directly around 15 to 30 minutes before you want the support.' },

      { pill: 'Why I listened',
        head: 'Coming from him was different.',
        body: 'At that point, I was down to try anything that had even a 1% chance of ' +
              'helping. But if it had come from some random ad or stranger online, I probably ' +
              'would have ignored it. Coming from him was different. He had been in my shoes ' +
              'before. He knew how embarrassing it was, how lonely it felt, and how hard it ' +
              'was to even say any of this out loud. Men do not really open up about this ' +
              'kind of stuff, especially with other men, so the fact that he even brought it ' +
              'up told me it had genuinely mattered to him. That was enough for me to give it ' +
              'a shot.' },

      { pill: 'The delivery',
        head: 'I remember looking at the sachet for a few minutes before opening it.',
        body: 'I ended up ordering one. When it showed up a couple days later, it came in ' +
              'discreet packaging, which I appreciated because the last thing I wanted was ' +
              'some giant box announcing my private business to everyone in the house. I ' +
              'remember looking at the sachet for a few minutes before opening it. I was ' +
              'still nervous, but I also kept thinking about what my friend had said. I was ' +
              'not expecting it to magically fix everything, and I definitely did not want to ' +
              'turn that night into another test. I just took it, went about my evening, and ' +
              'tried not to overthink it.' },

      { pill: 'That night',
        head: 'I was not checking myself every few seconds like I usually did.',
        body: 'Later that night, when my wife and I got close, I noticed I was not checking ' +
              'myself every few seconds like I usually did. I was not lying there thinking, ' +
              '"Is it happening yet?" I was actually focused on her and enjoying the moment, ' +
              'which honestly felt like a pretty big deal after everything that had been ' +
              'going on.' }
    ],

    closeHead: 'The bottom line',
    close:
      'I wish I could say more, but I am not going to blast the details of my intimate life ' +
      'with my wife all over the internet. But I can tell you this much: things are a lot ' +
      'better now, and I do not feel like I am constantly waiting for my body to let me down ' +
      'anymore. I am sharing this because I know there are probably a lot of men quietly ' +
      'dealing with the same thing and pretending it is just stress, age, or a one-time ' +
      'problem. If you are still attracted to your partner but keep getting stuck in your own ' +
      'head, you are not alone, and you are not automatically broken.',

    /* The script's own recommendation, kept as his and not restated as the
       page's. The url in it becomes the CTA rather than a printed link. */
    recommend:
      'But trust me, buddy, Honey Bae is worth a shot. It helped me feel more confident and ' +
      'get out of my head, which was exactly what I needed. If you want to look into the one ' +
      'my friend sent me, you can check it out here.',

    /* the script's last line, and the reason the page exists */
    signoff:
      'Just do not keep buying random products from the gas station without knowing what you ' +
      'are taking. That is the mistake I made.'
  };

  /* ---------- BRAND: Honey Bae's own, attributed ---------- */
  const BRAND = {
    what:
      'Honey Bae is honey in single-use 15g sachets, twelve to a pack, with the botanicals ' +
      'printed on the box. One sachet, taken directly, around 15 to 30 minutes beforehand.',

    botanicals:
      'Panax ginseng, Peruvian maca, tongkat ali and tribulus terrestris, the four ' +
      'botanicals Honey Bae lists on its own product page.',

    botanicalsNote:
      'Those are the traditional uses Honey Bae publishes for each botanical. They are the ' +
      'brand’s wording, not a finding, and this is a food supplement rather than a ' +
      'medicine. It is not intended to diagnose, treat, cure or prevent any disease.',

    guarantee:
      'Honey Bae publishes a 60-day money-back guarantee on its own product page: a full ' +
      'refund if you are not satisfied, with no returns required. The 3-month delivery plan ' +
      'is what buys the 30% off, and it can be skipped, delayed or cancelled before the next ' +
      'charge.',

    medical:
      'Difficulty of this kind has causes a supplement cannot address, including ' +
      'cardiovascular disease, diabetes, low testosterone and medication side effects, and it ' +
      'is sometimes the first sign of one of them. If it is persistent, it is worth raising ' +
      'with a doctor rather than managing off a shelf. Nothing on this page is medical advice.',

    /* the terms band at the very top. Terms, never a deadline. */
    band: {
      head: 'Welcome kit: 30% off, plus 5 free Gold Shilajit gummies.',
      note: 'Cancel any time. 60-day money-back guarantee.'
    },

    ticker: [
      'One 15g sachet',
      '15 to 30 minutes beforehand',
      'Panax ginseng, maca, tongkat ali',
      'Tribulus terrestris',
      'Ingredients printed on the pack',
      'Discreet packaging',
      'Cancel any time',
      '60-day money back'
    ],

    stats: [
      { n: '4',   l: 'botanicals on the label: ginseng, maca, tongkat ali, tribulus' },
      { n: '15g', l: 'a sachet, twelve sachets to a pack' },
      { n: '30',  l: 'minutes at the outside, and nothing to take daily' },
      { n: '0',   l: 'prescriptions, and no bottle to hide in the cabinet' }
    ],

    /* THE PICTURE IS A THUMBNAIL, NOT A BACKGROUND, and that is a fix rather
       than a preference. The first build of this section used the three Amazon
       gallery tiles as full-bleed card backgrounds, the way the Veyla lander
       does with its lifestyle photography. Those three files are infographics
       with the brand's own headlines set into them, so the result was the
       card's heading printed on top of a different heading, twice, in yellow.

       Honey Bae's usable library is cutouts on transparent grounds, which is
       the wrong shape for a background and exactly the right shape for a small
       object sitting on a dark card. So these are the cutouts, at thumbnail
       size, and the tiles stay where they work: full width, as beat art, with
       no text of ours over them. */
    cards: [
      { tag: 'The format', head: 'A sachet, not a bottle',
        body: 'Twelve single-use 15g sachets to a pack. Tear one open and take it directly. ' +
              'There is no scoop, no measuring and nothing to keep on a shelf where it can be ' +
              'seen.',
        img: '../_shared/img/hb-box-cutout.png' },
      { tag: 'The label', head: 'The ingredients are printed on it',
        body: 'Which is the whole difference the account above turns on: he had no idea what ' +
              'was in the packet from the gas station, and this one lists what is in it.',
        img: '../_shared/img/hb-box-sachet.png' },
      { tag: 'What is not in it', head: 'No soy, no gluten, no GMO',
        body: 'Honey Bae publishes the pack as gluten free, non-GMO and free of soy and ' +
              'parabens, with no artificial additives or fillers.',
        img: '../_shared/img/hb-boxes-marble.png' }
    ],

    chips: [
      { t: 'Panax ginseng', hi: true }, { t: 'Peruvian maca', hi: true },
      { t: 'Tongkat ali', hi: true },   { t: 'Tribulus terrestris', hi: true },
      { t: '100% pure honey' }, { t: 'Single-use 15g sachets' },
      { t: 'No artificial additives or fillers' }, { t: 'Gluten free' },
      { t: 'Non GMO' }, { t: 'No soy or parabens' },
      { t: 'Discreet packaging' }, { t: 'No prescription' }
    ],

    /* How he took it, drawn from the script and from the directions on the
       pack. Not a results timeline: this product has no week-by-week arc to
       promise and the page will not invent one. */
    how: [
      { ico: '①', wk: 'Before anything',
        head: 'Read what is in it',
        body: 'The thing the account above wishes he had done at the gas station. The ' +
              'botanicals are printed on the box and listed on the product page.' },
      { ico: '②', wk: 'One sachet',
        head: 'Tear it open, take it directly',
        body: 'No scoop, no water, no routine. It is honey, and the pack is twelve of them.' },
      { ico: '③', wk: '15 to 30 minutes',
        head: 'Then get on with your evening',
        body: 'The directions on the pack say around 15 to 30 minutes before you want the ' +
              'support. Nothing here is daily and nothing has to be scheduled.' },
      { ico: '④', wk: 'The part he got right',
        head: 'Do not turn it into a test',
        body: 'His own words: he took it, went about his evening, and tried not to overthink ' +
              'it. That is his account of what worked, not a claim of ours about what will.' }
    ],

    faqExtra: [
      { q: 'How it is taken',
        a: 'One 15g sachet, torn open and taken directly, around 15 to 30 minutes before you ' +
           'want the support. Twelve sachets to a pack. There is nothing to take daily, ' +
           'nothing to measure and no course to finish.' },
      { q: 'When this is not the right thing',
        a: 'Difficulty of this kind has causes a supplement cannot address, including ' +
           'cardiovascular disease, diabetes, low testosterone and medication side effects, ' +
           'and it is sometimes the first sign of one of them. If it is persistent, it is ' +
           'worth raising with a doctor rather than managing off a shelf. Honey Bae is a food ' +
           'supplement and is not intended to diagnose, treat, cure or prevent any disease. ' +
           'Nothing on this page is medical advice.' },
      { q: 'Who is telling this story',
        a: 'The account above is a first-person dramatization supplied to Honey Bae. The ' +
           'narrator and the friend are a composite, they are unnamed, and no photograph on ' +
           'this page is of either of them. The reviews on this page are real store reviews, ' +
           'reproduced as written under the names they were left under.' }
    ]
  };

  /* ---------- OUTSIDE ----------
     The script's own comparison is a labelled pack against an unlabelled one,
     so that is the comparison the table makes. IT DOES NOT COMPARE THIS TO A
     PRESCRIPTION MEDICINE. Putting a honey sachet in a column beside sildenafil
     implies they do the same job, which is a drug claim made by a table rather
     than by a sentence, and no arrangement of hedges makes it not one. The
     third column is a doctor, and it is there to say the thing the page would
     otherwise be quietly steering a reader away from. */
  const OUTSIDE = {
    packet: {
      label:  'An unlabelled gas station packet',
      /* NO FIGURE. We have no source for what these cost and the page will not
         invent a range to make a column look complete. What is true and what
         the argument needs is that each one is a fresh purchase. */
      cost:   'A few dollars each, bought again every time',
      note:   'The script names two, "Black Bull" and "Extreme Man", as the ones he tried. ' +
              'The page makes no claim about either product beyond his own account of not ' +
              'knowing what was in the one he took.'
    },
    doctor: {
      label:  'A doctor',
      cost:   'A consultation fee, and it varies',
      note:   'The right call for anything persistent, and the only column here that can ' +
              'look for a cause.'
    }
  };

  /* ---------- ART ----------
     Honey Bae's own product photography, from the live product page and from
     the Amazon listing already saved as theme assets.

     NO FACES ON THIS PAGE, and that is a rule rather than a preference. A man
     is speaking for eleven paragraphs about something that happened in his
     bedroom and he does not exist, so any man's face near that copy is read as
     him. The library's face shots are therefore all unused and the harness
     fails on any of them by filename:

       hb-amz-gallery-2.jpg   the running athlete
       hb-amz-gallery-4.jpg   the man in a suit opening a sachet
       hb-amz-gallery-5.jpg   the couple on the sofa
       hb-amz-gallery-7.jpg   the beekeeper
       Rectangle_85           the man in a suit, again
       Rectangle_95           the couple, again

     There is no exception on this page. Veyla's lander allowed one, a piece of
     brand campaign creative with the brand's own headline set into it, because
     a reader reads that as an advertisement. Honey Bae's equivalent shot is the
     beekeeper, and the difference is that he is a man of roughly the narrator's
     description doing something ordinary, which is exactly the read the rule
     exists to prevent.

     ALSO UNUSED: Rectangle_67, which has "43,000+ SATISFIED CUSTOMERS" burned
     into the image. A count the page refuses to print in text does not become
     printable by being inside a photograph. See SWAPS.ratings.

     `w` and `h` are the real pixel sizes on disk. The harness reads those
     headers off the files and fails if either drifts, because a width/height
     pair that does not match its file is what squashes a photograph. */
  const ART = {
    hero:   { src: '../_shared/img/hb-sachet-botanicals.jpg', w: 1254, h: 1254,
              alt: 'A single Honey Bae sachet on marble with ginseng root, maca and a honey dipper' },

    cutout: { src: '../_shared/img/hb-box-cutout.png', w: 842, h: 938,
              alt: 'The Honey Bae twelve sachet pack, front and side of the box' },

    /* ---------- THE RETIRED SHOTS ----------
       Still shipped and still referenced, but no longer paired to a beat: the
       three BRAND.cards thumbnails name these by filename and read their pixel
       size back out through artByFile. They live here so replacing the beat art
       does not silently drop the width/height off those three thumbnails and
       reintroduce the layout shift they were sized to prevent. */
    library: [
      { src: '../_shared/img/hb-hand-box.png', w: 1574, h: 1050,
        alt: 'A hand holding the Honey Bae pack, no face in frame' },
      { src: '../_shared/img/hb-box-sachet.png', w: 1114, h: 1114,
        alt: 'The pack and one sachet, showing the label' },
      { src: '../_shared/img/hb-boxes-marble.png', w: 672, h: 502,
        alt: 'Three Honey Bae packs on a counter' },
      { src: '../_shared/img/hb-pack-white.jpg', w: 1500, h: 1500,
        alt: 'The twelve sachet pack beside a single 15g sachet' },
      { src: '../_shared/img/hb-honey-pure.jpg', w: 1500, h: 1500,
        alt: 'Honey Bae\u2019s own image for the honey' },
      { src: '../_shared/img/hb-sachet-badges.jpg', w: 1500, h: 1500,
        alt: 'A single sachet beside the pack\u2019s gluten free, non GMO and no soy marks' }
    ],

    /* One per beat, in the script's order, paired by index. Six of the ten
       beats carry a photograph and four do not. A beat with no art still
       renders, and the four that stay empty are the ones no honest photograph
       covers: the 2 AM scrolling, the two conversations with the friend, and
       the paragraph about why he listened to him.

       ON THE FACES IN THIS SET. The original build carried a no-faces rule and
       these placements break it deliberately, at Omar\u2019s instruction on
       2026-08-18. The four people shots are placed against the beats whose copy
       is about the marriage rather than the product, and the byline disclosure
       above the story already says in the page\u2019s own voice that the
       narrator is a composite and that no photograph on the page is of him or
       of the friend. That disclosure is load-bearing now in a way it was not
       before: it is the only thing separating these faces from a claim that
       they are the people in the account. It does not get deleted. */
    beats: [
      /* 0 | What was wrong \u2014 "Nothing was wrong between us." The marriage as
            it looked from the outside, which is the beat\u2019s whole point. */
      { src: '../_shared/img/hb-couple-kitchen.jpg', w: 1254, h: 1254,
        alt: 'A couple at home in a kitchen, sitting close together' },

      /* 1 | The silence \u2014 42, embarrassed, told nobody. One person, alone,
            at the end of a day. */
      { src: '../_shared/img/hb-man-alone.jpg', w: 1254, h: 1254,
        alt: 'A man sitting alone at a kitchen table at dusk with a mug' },

      /* 2 | 2 AM \u2014 no photograph. There is no honest picture of this. */
      null,

      /* 3 | The gas station \u2014 the beat is literally the difference between an
            unlabelled packet and a labelled one, and this is that difference in
            one frame. */
      { src: '../_shared/img/hb-packet-vs-pack.jpg', w: 1254, h: 1254,
        alt: 'An unlabelled silver packet at a gas station beside a labelled Honey Bae sachet on a kitchen counter' },

      /* 4 | The friend \u2014 no photograph. Two men talking after a few beers is
            a stock shot standing in for somebody who does not exist. */
      null,

      /* 5 | The link \u2014 "read it before you buy another piece of junk." The
            four botanicals, laid out, which is what reading it turns up. */
      { src: '../_shared/img/hb-botanicals-flatlay.jpg', w: 1254, h: 1254,
        alt: 'A Honey Bae sachet laid out with ginseng root, maca, tongkat ali, tribulus and honeycomb' },

      /* 6 | What I read \u2014 the ingredients listed. The notebook names the same
            four the pack and the product page do. */
      { src: '../_shared/img/hb-notebook-label.jpg', w: 1254, h: 1254,
        alt: 'A notebook listing ginseng, maca root, tongkat ali, tribulus and honey beside a Honey Bae sachet' },

      /* 7 | Why I listened \u2014 no photograph. */
      null,

      /* 8 | The delivery \u2014 "looking at the sachet for a few minutes before
            opening it." Tear, pour, stir: the thing he was looking at. */
      { src: '../_shared/img/hb-how-to-use.jpg', w: 1254, h: 1254,
        alt: 'Four steps: holding a sachet, tearing it open, pouring it into a glass of water and stirring' },

      /* 9 | That night \u2014 the payoff beat, and the only one the copy earns a
            picture of two people for. */
      { src: '../_shared/img/hb-couple-laughing.jpg', w: 1254, h: 1254,
        alt: 'A couple laughing together at home' }
    ],

    /* ---------- THE CLOSE SLOT, NOW FILLED ----------
       Omar asked for a picture in the bottom-line section 2026-08-16 and
       supplied the file 2026-08-18. It sits between his last paragraph and the
       button, which is the beat where he stops telling the story.

       The build\u2019s original note said this slot could not be a man, because it
       sits directly under the narrator\u2019s last paragraph and any man there is
       read as him. It is a man, at Omar\u2019s instruction. What carries it is the
       copy immediately above: the close is about things being better, this is a
       morning at home, and the byline disclosure covers the read. */
    close: {
      src: '../_shared/img/hb-couple-morning.jpg', w: 1254, h: 1254,
      ratio: '1 / 1',
      alt: 'A couple making breakfast together in a sunlit kitchen'
    }
  };

  /* ---------- BUY: the offer panel's own words ----------
     THIS PAGE ROUTES. It does not charge. The reader picks the plan on the
     product page, where the selling plan and the cart are the same surface, and
     where the Kaching bundle app that prices this product actually lives.

     So the panel quotes the OFFER the script's close promises, and says out
     loud where the real one is. Every figure it prints is computed from
     hb-offer.js, so a repricing moves the page rather than a developer. */
  const BUY = {
    pdpUrl:   '/products/honey-bae-natural-honey',
    badge:    '5 free Gold Shilajit gummies',
    eyebrow:  'The offer this page is about',
    headTail: 'on the 3-month delivery plan',
    cta:      'Check Availability',
    /* NO FIGURE IS TYPED IN THIS STRING. The saving, the plan price and the
       list price are all painted by the engine from hb-offer.js, and the
       harness fails if a dollar figure ever appears in this file. */
    note:     'Price, plans and availability are shown on the product page, which is where ' +
              'the plan is chosen and the order is placed. The saving is measured against the ' +
              'price the store itself lists a single pack at, not against a comparison figure ' +
              'invented for this page. The plan can be skipped, delayed or cancelled before ' +
              'the next charge, and the guarantee is Honey Bae’s own published one.',
    stats: [
      { n: '60 days',      l: 'money back' },
      { n: 'Cancel',       l: 'any time' },
      { n: 'Free priority', l: 'shipping' }
    ],
    stickyHead: 'Honey Bae Natural Honey',
    stickySub:  '12 sachets, 15g each'
  };

  /* ---------- REVIEWS: real, named, from Honey Bae's own store ----------
     These matter more on this page than anywhere else on it, because the
     article above them is a composite. They are the store's own reviews,
     reproduced as written, under the names they were left under.

     THERE ARE TWO AND THERE SHOULD BE THREE. The store shows three; the third
     is excluded on purpose. See REFUSED.testimonial. Two real reviews beat
     three where one has been invented to fill a grid, and the section says two. */
  const REVIEWS = {
    note: 'Reproduced as written from Honey Bae’s own store.',
    pull: {
      name: 'EOFugate', tag: 'Store review, "Great Taste & Nice Natural Boost"', stars: 5,
      body: 'I really liked this product! The honey sachets are super convenient and easy to ' +
            'take on the go, just tear and enjoy. The flavor is smooth and natural, not overly ' +
            'sweet like some other honey supplements.'
    },
    list: [
      { name: 'Allan', tag: 'Store review, "Awesome product"', stars: 5,
        body: 'Was very satisfied with it!' },
      { name: 'EOFugate', tag: 'Store review, "Great Taste & Nice Natural Boost"', stars: 5,
        body: 'I really liked this product! The honey sachets are super convenient and easy ' +
              'to take on the go, just tear and enjoy. The flavor is smooth and natural, not ' +
              'overly sweet like some other honey supplements.' }
    ]
  };

  const REFUSED = {
    efficacy:
      'The page makes no claim of its own about what this product does. Every ' +
      'statement about an effect is either the narrator’s account, hedged as ' +
      'his, or Honey Bae’s own wording, attributed to Honey Bae.',
    medical:
      'No claim to treat, cure, prevent or diagnose anything, and no comparison ' +
      'to a prescription medicine anywhere, including inside the comparison ' +
      'table. See the note on OUTSIDE.',
    testimonial:
      'The store’s third review, left under the name "Snacks", reads "Works ' +
      'good for longer erections great product". It is real and it is not on this ' +
      'page. A testimonial is a claim the advertiser has to be able to stand ' +
      'behind, so quoting a customer reporting an erectile result puts an ' +
      'efficacy claim on the page that the rest of the page spent its whole ' +
      'length refusing to make.',
    ratings:
      'No rating and no review count. The client’s own product page carries ' +
      'three that contradict each other. See SWAPS.ratings.',
    urgency:
      'No countdown, no stock counter, no deadline. The 30% is a standing plan ' +
      'discount rather than an expiring offer, and the band says the terms ' +
      'instead.',
    timeline:
      'No week-by-week results arc. The "how" panel describes taking it, which is ' +
      'the only sequence this product has.',
    face:
      'No photograph is captioned or presented as the narrator or the friend. The ' +
      'page does carry people, at Omar\u2019s instruction 2026-08-18, against the beats ' +
      'whose copy is about the marriage rather than the product. The byline ' +
      'disclosure says in the page\u2019s own voice that the account is a composite and ' +
      'that nobody pictured is either man in it, and it is what makes the people ' +
      'shots readable as illustration. See ART.',
    profanity:
      'No profanity, anywhere on the page. See SWAPS.profanity.',
    competitors:
      'The two gas station brands are named because the script named them, in his ' +
      'account of what he tried. No claim is made about either product’s ' +
      'contents, safety or effect: what the copy says is that he did not know ' +
      'what was in the one he took, which is a statement about him.'
  };

  window.HN_SOURCE = { SCRIPT, SWAPS, FICTION, BRAND, OUTSIDE, ART, BUY, REVIEWS, REFUSED };
})();
